<template>
  <div>
    <div class="login">
      <div class="form">
        <div class="logo">
          <img src="@/assets/img/logo.png" alt />
        </div>
        <div class="form-group">
          <label>Usuario</label>
          <input type="text" class="form-control" placeholder="usuario" v-model="usuario" />
        </div>
        <div class="form-group">
          <label>Contraseña</label>
          <input type="password" class="form-control" placeholder="contraseña" v-model="password" />
        </div>

        <div class="form-group d-flex justify-content-center" v-if="loader">
          <div class="spinner-border text-primary text-center" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div class="form-group" v-if="!loader">
          <span
            class="btn btn-block btn-primary"
            @click.prevent="ingresoUsuario({usuario:usuario, password:password})"
          >Accesar</span>
        </div>

        <div class="form-group" v-if="error">
          <div class="alert alert-danger text-center" role="alert">{{error}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      usuario: "",
      password: ""
    };
  },
  methods: {
    ...mapActions(["ingresoUsuario"])
  },
  computed: {
    ...mapState(["error", "loader"])
  },
  mounted: function() {
    this.$store.commit("setError", false);
  }
};
</script>

